import React from 'react';
import { cn } from '../../lib/utils';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}
export function Card({
  className,
  interactive = false,
  children,
  ...props
}: CardProps) {
  return <div className={cn('bg-white rounded-xl border border-gray-100 shadow-soft overflow-hidden', interactive && 'transition-all hover:shadow-md hover:-translate-y-0.5 cursor-pointer', className)} {...props} data-id="element-1795">
      {children}
    </div>;
}
export function CardHeader({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 flex flex-col space-y-1.5', className)} {...props} data-id="element-1796" />;
}
export function CardTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-semibold leading-none tracking-tight text-gray-900', className)} {...props} data-id="element-1797" />;
}
export function CardContent({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 pt-0', className)} {...props} data-id="element-1798" />;
}
export function CardFooter({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 pt-0 flex items-center', className)} {...props} data-id="element-1799" />;
}